module.exports = __webpack_public_path__ + "img/avatarMale.6284d458.jpg";